import React from "react";
import ReactDOM from "react-dom/client";
import { createFeatureHub } from "@feature-hub/core";
import { FeatureHubContextProvider } from "@feature-hub/react";
import { loadFederatedModule } from "@feature-hub/module-loader-federation";
import { App } from "./app";

// Lokaler Einstieg wie der demo-integrator im ADAC-Repo: lädt die Feature App als föderiertes Modul.
const { featureAppManager } = createFeatureHub("carsearch-demo-integrator", { moduleLoader: loadFederatedModule });
const root = ReactDOM.createRoot(document.getElementById("vehicle-advisor-feature-app")!);
root.render(
  <React.StrictMode>
    <FeatureHubContextProvider value={{ featureAppManager }}>
      <App />
    </FeatureHubContextProvider>
  </React.StrictMode>
);
